import * as t from './actionTypes';

const initialState = { isLoading: false, friends: [] };

const friendReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.FRIEND_LOAD_SUCCESS:
            var friends = action.friends;
            var friendArr = [];

            for (var friend in friends) {
                friendArr.push(friends[friend]);
            }

            return Object.assign({}, state, { friends: friendArr });

        case t.FRIEND_CREATE_SUCCESS:
            friend = action.friend;

            friends = state.friends;
            if (!friends) friends = [];
            friends.push(friend);

            state = Object.assign({}, state, { friends: friends });
            
            return state;

        case t.FRIEND_EDIT_SUCCESS:
         /*   var newFriend = action.friend;

            var curFriends = state.friends;
            for (var i = 0; i < curFriends.length; i ++) {
                if (curFriends[i].id === action.id) {
                    curFriends[i] = newFriend;
                    break;
                }
            }*/

            return {
                ...state,
                friends: state.friends.map(v => v.id !== action.id ? v : {...v, ...action.friend})
            };

        case t.FRIEND_DELETE_SUCCESS:
            let curFriends = state.friends;

            for (let i = 0; i < curFriends.length; i ++) {
                if (curFriends[i].id === action.id) {
                    curFriends.splice(i, 1);
                    break;
                }
            }

            state = Object.assign({}, state, { friends: curFriends });

            return state;
            
        default:
            return state;
    }
};

export default friendReducer;